export default function getIntegrationsConfigName(projectId: string) {
  return `project.${projectId}.integrations`
}
